<template>
    <div @click="itemClick">
        <div ><slot></slot></div>
    </div>
</template>

<script>
    export default {
        name: "LinkMobile",
        props:{
            link:{
                type:String,
                required:true
            },
        },
        methods:{
            itemClick(){
                this.$router.replace(this.link)
            }
        }
    }
</script>

<style scoped>

</style>